import React from "react";
import ExternalScripts from "../../../common/ExternalScripts";
import { Link } from "react-router-dom";

const PricingSection = () => {
  return (
    <div>
      <ExternalScripts/>
      {/* pricing section */}
      <section className="boxcar-pricing-section pb-0 pt-0">
        <div className="large-container">
          <div className="row g-0">
            {/* image-column */}
            <div className="image-column col-lg-6 col-md-12 col-sm-12">
              <div className="inner-column">
                <div className="image-box">
                  <figure className="image">
                    <a >
                      <img src="images/resource/pricing1-1.jpg"   />
                    </a>
                  </figure>
                  {/* <a
                    href="https://www.youtube.com/watch?v=AC1cREPIw_o&autoplay=1&rel=0&controls=0&showinfo=0"
                    className="play-now"
                    data-fancybox="gallery"
                    data-caption
                  >
                    <i className="fa fa-play" aria-hidden="true" />
                    <span className="ripple" />
                  </a> */}
                </div>
              </div>
            </div>
            <div className="content-column col-lg-6 col-md-12 col-sm-12">
              <div className="inner-column">
                <div className="boxcar- wow fadeInUp">
                  <h2>Find Your Perfect Car at the Right Price</h2>
          <div className="text">
            Explore a wide selection of quality-checked cars at competitive prices.
            We make buying your next car simple, transparent, and completely stress-free.
          </div>
            <ul className="list-style-one wow fadeInUp" data-wow-delay="100ms">
              <li>
                <i className="fa-solid fa-check" />
                Wide range of verified cars across all brands and budgets
              </li>
              <li>
                <i className="fa-solid fa-check" />
                Transparent pricing with no hidden costs
              </li>
              <li>
                <i className="fa-solid fa-check" />
                Easy financing, documentation, and ownership transfer support
              </li>
            </ul>
                <Link
                  to={'/Inventory'}
                  className="read-more wow fadeInUp"
                  data-wow-delay="200ms"
                >
                  View All
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={14}
                    height={14}
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_634_2156)">
                      <path
                        d="M13.6106 0H5.05509C4.84013 0 4.66619 0.173943 4.66619 0.388901C4.66619 0.603859 4.84013 0.777802 5.05509 0.777802H12.6719L0.113453 13.3362C-0.0384687 13.4881 -0.0384687 13.7342 0.113453 13.8861C0.189396 13.962 0.288927 14 0.388422 14C0.487917 14 0.587411 13.962 0.663391 13.8861L13.2218 1.3277V8.94447C13.2218 9.15943 13.3957 9.33337 13.6107 9.33337C13.8256 9.33337 13.9996 9.15943 13.9996 8.94447V0.388901C13.9995 0.173943 13.8256 0 13.6106 0Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_634_2156">
                        <rect width={14} height={14} fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End pricing section */}
    </div>
  );
};

export default PricingSection;
